export const ptBR = {
    panelTitle: "Painel do Assessor",
    managerPanelTitle: "Painel do Gerente",
    importData: "Importar dados",
    rankingSectionTitle: "Critérios de priorização",
    rankingSectionSubtitle: "Critérios usados para priorizar as sugestões de investimento recomendadas aos clientes.",
    rankingExampleCriterion: "FICs e FIIs com maior exposição a liquidez nos próximos 30 dias.",
    opportunityVolumeLabel: "Valor da oportunidade",
    rankingPreviewShow: "Ver critérios de priorização",
    rankingPreviewHide: "Ocultar critérios de priorização",
    rankingPreviewLoadError: "Não foi possível carregar os critérios do servidor.",
    rankingPreviewNotConfigured: "Utilizando ordenação padrão da plataforma",
    rankingPreviewEditedMeta: "Última edição: {name} · {date}",
    rankingEditForbidden: "Apenas gerentes podem alterar rankings. Use o Painel do Gerente.",
    rankingViewProperties: "Ver propriedades do ranking",
    rankingHideProperties: "Ocultar propriedades do ranking",
    rankingPropertiesModalTitle: "Propriedades — {market}",
    rankingPropertiesLoadError: "Não foi possível carregar as propriedades do ranking.",
    rankingPropertiesEmpty: "Nenhuma propriedade disponível para este mercado.",
    rankingPropertiesClickHint:
        "Clique em uma propriedade ou valor para montar o critério no campo abaixo.",
    rankingClarificationOtherOption: "Outro (especificar)",
    rankingClarificationFreeformPlaceholder: "Digite sua resposta",
    rankingClarificationConfirm: "Confirmar respostas",
    rankingClarificationSubmitError: "Não foi possível enviar sua resposta. Tente novamente.",
    rankingPropertiesOrderingTitle: "Ordenar por",
    rankingPropertiesFilteringTitle: "Filtrar por",
    rankingPropertiesExpandModal: "Expandir",
    rankingPropertyHigher: "maior",
    rankingPropertyLower: "menor",
    rankingPropertyNewer: "mais recente",
    rankingPropertyOlder: "mais antigo",
    rankingPropertyFilterGt: "maior que…",
    rankingPropertyFilterLt: "menor que…",
    rankingPropertyFilterAfter: "após…",
    rankingPropertyFilterBefore: "antes de…",
    rankingPropertyFilterValuePlaceholder: "Valor",
    rankingPropertyFilterDatePlaceholder: "Data (ex.: 2020-01-15)",
    rankingPropertyFilterApply: "Inserir",
    rankingPropertyFilterCancel: "Cancelar",
    rankingPropertyFilterInvalidValue: "Informe um número válido.",
    rankingPropertyFilterInvalidDate: "Informe uma data.",
    rankingPropertyYes: "sim",
    rankingPropertyNo: "não",
    rankingChatPlaceholder: "Ex.: maior retorno, menor liquidez… (use as propriedades acima)",
    rankingConfirmHint: "Confirme para aplicar o ranking a este mercado, ou cancele para descartar.",
    rankingConfirmButton: "Confirmar e aplicar",
    rankingCancelButton: "Cancelar sugestão",
    rankingConfirmUserMessage: "Confirmar",
    rankingCancelUserMessage: "Cancelar",
    chatMessageSendError: "Não foi possível enviar sua mensagem. Tente novamente.",
    chatStreamingStarting: "Iniciando...",
    opportunitiesOnManagerPanel:
        "Oportunidades e criação de novas metas ficam no Painel do Gerente. Use a aba acima para alternar.",
    clientsOverview: "Visão geral de clientes",
    // Visão consolidada da execução (painel do Gestor)
    periodMTD: "MTD",
    periodYTD: "YTD",
    periodCustom: "Personalizado",
    periodCustomStart: "Início",
    periodCustomEnd: "Fim",
    vsPreviousPeriod: "vs. período anterior",
    executionPerformanceOverviewTitle: "Visão consolidada da execução",
    executionPerformanceOverviewSubtitle:
        "Quanto do volume oferecido em oportunidades virou movimentação de fato na janela selecionada.",
    executionPerformanceLoadError: "Não foi possível carregar a visão consolidada da execução do servidor.",
    executionCombinedCardLabel: "Execução de oportunidades",
    executionAverageLabel: "Consolidado",
    advisorCurvesTitle: "Curva de execução no período",
    executionNoDataInWindow: "Sem movimentação associada a oportunidade nesta janela.",
    executionByAdvisorTitle: "Performance por assessor",
    executionByOpportunityTitle: "Performance por oportunidade",
    executionUnassignedAdvisor: "Sem assessor",
    executionUntitledOpportunity: "Oportunidade sem título",
    basisSettled: "Liquidado",
    basisWithPending: "Com em trânsito",
    executionPendingHint: "{value} pedido, ainda não liquidado",
    unitVolume: "Volume financeiro",
    unitClients: "Qtde de clientes",
    scatterAxisLabel: "Eixo horizontal: {xAxisLabel} · Eixo vertical: {yAxisLabel}",
    scatterYAxisVolumeLabel: "volume executado (R$)",
    scatterYAxisClientsLabel: "clientes executados",
    scatterXAxisExecutionLabel: "performance de execução (%)",
    scatterQuadrantFavorable: "Favorável nos dois eixos",
    scatterQuadrantUnfavorable: "Desfavorável nos dois eixos",
    scatterQuadrantMixed: "Favorável em só um dos eixos",
    volumeUnderCustody: "Volume sob custódia",
    opportunities: 'Oportunidades',
    welcomeText1: "Bem vindo de volta",
    todayIs: "Hoje é",
    itIsTime: "São",
    seeMore: "Ver mais",
    seeClients: "Ver Clientes",
    contextMessage: "Contexto",
    commitments: "Compromissos",
    nextContributionPerClient: "Próximos vencimentos e aportes de clientes",
    top3Clients: "Top 3 clientes em patrimônio",
    clientsTotal: "Total de clientes",
    addObjective: "Adicionar Objetivo",
    addNewOpportunity: "Adicionar nova oportunidade",
    objectiveDraftModalTitle: "Novo objetivo",
    objectiveDraftReviewTitle: "Rever rascunho",
    objectiveDraftIntro:
        "Descreva a estratégia em linguagem natural. Vamos gerar um rascunho: a IA propõe uma interpretação. Depois pode ajustar o texto e regerar, ou confirmar para gravar.",
    objectivePromptLabel: "Estratégia (prompt)",
    objectivePromptHelper:
        "Este é o texto principal que a IA usa para entender o objetivo e estimar impacto. Quanto mais claro, melhor o rascunho.",
    objectiveReportTitleLabel: "Nome do relatório (opcional)",
    objectiveCardStrategyLabel: "Estratégia",
    objectiveStartDateLabel: "Data de início",
    objectiveStartDateHelper:
        "Hoje ou uma data no passado. Define a carteira de referência dos clientes impactados.",
    objectiveStartDateFutureError: "A data de início não pode ser futura.",
    objectiveEndDateBeforeStartError: "A data de fim precisa ser posterior à data de início.",
    objectiveGenerateDraftButton: "Gerar rascunho",
    objectiveReviewHeading: "Revisão do rascunho (nada foi gravado ainda)",
    objectiveExpiresHint: "Este rascunho expira em",
    objectiveInterpretationHeading: "O que a IA entendeu",
    objectiveCypherHeading: "Consulta gerada (somente leitura)",
    objectiveImpactedPreviewHeading: "Pré-visualização de impacto",
    objectiveImpactedCount: "Total de linhas estimadas",
    objectiveWarningsHeading: "Alertas",
    objectiveStrategyAdjustLabel: "Ajustar texto da estratégia e regerar",
    objectiveRegenerateButton: "Regerar rascunho",
    objectiveCommitButton: "Confirmar e gravar objetivo",
    objectiveBackToFormButton: "Voltar ao formulário",
    objectivePreviewEmpty: "Sem linhas no pré-visualizador.",
    objectiveDraftCannotCommit:
        "A consulta não foi validada. Ajuste a estratégia ou regenere o rascunho antes de confirmar.",
    objectiveCommitSuccess: "Objetivo criado com sucesso.",
    opportunityCreatedNotification: "Nova oportunidade: {title}",
    opportunityUpdatedNotification: "Oportunidade atualizada: {title}",
    opportunityDeletedNotification: "Oportunidade removida: {title}",
    opportunityUntitled: "Sem título",
    objectiveMonitoringBadge: "Monitoramento",
    objectiveSeeByPortfolio: "Ver por carteira",
    objectiveHidePortfolio: "Ocultar carteiras",
    objectiveMonitorAction: "Monitorar",
    objectiveMonitorCollapse: "Ocultar",
    objectiveMonitoringMeta: "{portfolioCount} carteiras · {movementCount} movimentos",
    objectiveMonitoringSummary: "Resumo da Execução",
    objectiveMonitoringSummaryOfTotal: "de {total}",
    objectiveMonitoringPortfolioCol: "Carteira",
    objectiveMonitoringAdvisorCol: "Assessor",
    objectiveMonitoringAmountCol: "Valor executado",
    objectiveMonitoringOpportunityTotalCol: "Valor oportunidade (Ver Clientes)",
    objectiveMonitoringPercentDoneCol: "Percentual executado",
    objectiveMonitoringNA: "N/A",
    objectiveMonitoringSortHintDesc: "Ordenado: maior % feito primeiro",
    objectiveMonitoringSortHintAsc: "Ordenado: menor % feito primeiro",
    objectiveMonitoringSortToggleAria: "Inverter ordem da coluna percentual feito",
    objectiveMonitoringNoAdvisor: "Sem assessor",
    objectiveMonitoringGroupModePortfolio: "Ver por carteira",
    objectiveMonitoringGroupModeAdvisor: "Ver por assessor",
    objectiveMonitoringGroupModeAria: "Alternar entre visão por carteira ou por assessor",
    // Visualização: linha do tempo / barras / tabela
    objectiveMonitoringViewTimeline: "Linha do tempo",
    objectiveMonitoringViewChart: "Barras",
    objectiveMonitoringViewTable: "Tabela",
    objectiveMonitoringViewAria: "Alternar entre linha do tempo, barras e tabela",
    objectiveMonitoringMetricVolume: "Volume",
    objectiveMonitoringMetricClients: "Clientes",
    objectiveMonitoringMetricAria: "Alternar métrica entre volume financeiro e clientes feitos",
    objectiveMonitoringChartTitle: "Percentual executado por assessor",
    objectiveMonitoringChartAxisHint: "0% — 100%",
    objectiveMonitoringChartPortfolios: "Carteiras",
    objectiveMonitoringChartConsolidated: "Consolidado",
    objectiveMonitoringChartEmpty: "Sem dados de assessor para exibir no gráfico.",
    objectiveMonitoringOpportunityShort: "Valor oportunidade",
    objectiveMonitoringByAdvisorTitle: "Execução por assessor",
    objectiveMonitoringClientsCol: "Clientes feitos",
    objectiveMonitoringClientsDoneShort: "{done}/{total} clientes",
    objectiveMonitoringClientsDoneLabel: "{done} de {total} clientes feitos",
    objectiveMonitoringClientDone: "Feito",
    objectiveMonitoringClientNotDone: "Não feito",
    objectiveMonitoringClientStatusCol: "Status",
    objectiveMonitoringClientsAdesaoHint: "Adesão: clientes com volume executado acima de 0%",
    objectiveMonitoringVolumeHint: "Percentual do volume financeiro executado",
    objectiveMonitoringTimelineTitle: "Execução ao longo do tempo",
    objectiveMonitoringTimelineHint:
        "Acumulado desde o início da campanha até hoje (ou o vencimento)",
    objectiveMonitoringTimelineHintByAdvisor:
        "Uma linha por assessor que executou · acumulado na janela da campanha",
    objectiveMonitoringTimelineTotal: "Total",
    objectiveMonitoringTimelineMoreAdvisors: "+{count} assessores",
    objectiveMonitoringTimelineDaily: "Volume do dia",
    objectiveMonitoringTimelineCumulative: "Acumulado",
    objectiveMonitoringTimelineMovements: "{count} movimentos",
    objectiveMonitoringTimelineEmpty:
        "Sem janela de datas da campanha para montar a evolução temporal.",
    objectiveMonitoringDrilldownEmpty:
        "Selecione um ou mais assessores à esquerda para ver as carteiras.",
    objectiveMonitoringSelectedSummaryLabel: "Selecionados ({count})",
    objectiveMonitoringEmpty:
        "Sem dados de monitoramento por carteira para este objetivo (ou consulta de movimento não armazenada).",
    objectiveMonitoringRollupsHint:
        "Carregue os dados agregados por carteira uma vez para ver movimentação neste e nos demais objetivos com monitoramento.",
    // Comparativo agregado de oportunidades (multi-seleção no painel do gestor)
    aggOpportunitiesBadge: "Comparativo",
    aggOpportunitiesTitle: "Execução agregada por assessor",
    aggOpportunitiesSubtitle:
        "{count} oportunidades · barra única de progresso global por assessor; cada fatia = contribuição da oportunidade (peso × execução)",
    aggOpportunitiesNoAdvisor: "Sem assessor",
    aggOpportunitiesPotentialLabel: "Potencial",
    aggOpportunitiesExecutedLabel: "Executado",
    aggOpportunitiesExecutionLabel: "Execução",
    aggOpportunitiesAvgCol: "% global",
    aggOpportunitiesShareSuffix: "do total do assessor",
    aggOpportunitiesGlobalProgressSuffix: "do progresso global",
    aggOpportunitiesByAdvisorTitle: "Assessores",
    aggOpportunitiesByAdvisorHint:
        "Progresso global ponderado pelo valor · sob o nome: clientes feitos (únicos, execução > 0%) · clique para detalhar",
    aggOpportunitiesDrilldownTitle: "Detalhe por oportunidade e carteira",
    aggOpportunitiesDrilldownEmpty: "Selecione um ou mais assessores à esquerda.",
    aggOpportunitiesCarteirasTitle: "Carteiras",
    aggOpportunitiesEmpty: "Sem valor de oportunidade para exibir.",
    dueDate: "Vencimento",
    objectiveExpiredLabel: "Vencida em",
    expiredBadge: "Vencida",
    showExpiredOpportunities: "Oportunidades vencidas",
    addedAt: "Adicionado em",
    impactedClients: "Clientes impactados",
    dones: "feitos",
    done: "feito",
    of: "de",
    loading: "carregando",
    showMoreOpportunities: "Ver mais oportunidades",
    showLessOpportunities: "Ver menos oportunidades",
    clients: "clientes",
    hideAll: "Esconder todos",
    showAll: "Expandir todos",
    liquidityEvents: "Eventos de liquidez",
    optQuantity: "Quantidade de oportunidades",
    events: "eventos",
    event: "evento",
    reference: "referência",
    equity: "Patrimônio",
    motive: "motivo",
    weekLiquidityEvent: "Evento de liquidez essa semana",
    rebalancing: "Rebalanciamento (relatório de pesquisa)",
    invSugestions: "Sugestão de investimentos",
    opportunitiesRelatedTo: "oportunidades relacionadas a",
    liquidityStream: "Fluxo de liquidez",
    maturity: "Vencimento",
    suitability: "Adequação",
    comission: "Comissão",
    product: "Produto",
    category: "Categoria",
    sugestInvestimentMsg: "Sugestão de mensagem",
    search: "Pesquisar",
    opportunityRelatedTo: "oportunidade relacionada a",
    all: "Todos",
    resolved: "Feitos",
    unresolved: "Não feitos",
    week: "Semana",
    day: "Dia",
    vencimento: "Vencimento",
    caixa: "Caixa",
    openFinance: "Open Finance",
    accountLabel: "Conta",
    financialInstitution: "Instituição",
    oportunidade: "Oportunidade",
    eventValueAll: "Todos",
    eventValueLow: "< 100k",
    eventValueMid: "100k - 500k",
    eventValueHigh: "> 500k",
    cashMinNominal: "Mínimo nominal (R$)",
    cashMinRelative: "Mínimo relativo (%)",
    investment: "Investimento",
    investmentDetails: "Detalhes do Investimento",
    type: "Tipo",
    liquidity: "Liquidez",
    month: "Mês",
    year: "Ano",
    m12: '12M',
    m24: '24M',
    m36: '36M',
    assetManager: "Gestor de ativos",
    cnpj: "CNPJ",
    benchmark: "Benchmark",
    effectiveReturn: "Retorno efetivo",
    public: "Público",
    minimalApplication: "Mínimo de aplicação",
    globalInterest: "Taxa global", 
    globalRate: "Taxa global",
    referenceRate: "Taxa de referência",
    yourWeek: "Sua semana",
    totalAmount: "Valor total",
    overview: "Visão geral",
    cashOnHand: "Dinheiro em caixa",
    yourClients: "Seus clientes",
    // Manager (consolidated) overview
    teamWeek: "Consolidado da equipe",
    teamClients: "Clientes da equipe",
    teamAdvisorsAggregated: "Agregado de {advisors} assessores",
    // Opportunities section redesign
    statusFilterLabel: "Status",
    statusActive: "Ativas",
    statusAll: "Todas",
    statusExpired: "Vencidas",
    editObjectiveModalTitle: "Editar oportunidade",
    editObjectiveSuccess: "Oportunidade atualizada com sucesso.",
    objectiveEditTitleLabel: "Título",
    objectiveEditWindowHint:
        "A data de início define a carteira de referência dos clientes impactados; ao alterá-la, os vínculos da oportunidade são recalculados.",
    startDate: "Início",
    editObjectiveAria: "Editar oportunidade",
    cancel: "Cancelar",
    save: "Salvar",
    saving: "Salvando...",
    generateStrategy: "Contextualizar o assistente",
    dueToday: "Vence hoje",
    dueTomorrow: "Vence amanhã",
    dueInDaysLabel: "Vence em {days} dias",
    overdueByDaysLabel: "Vencida há {days} dias",
    metricOpportunities: "oportunidades",
    metricImpactedClients: "clientes impactados",
    metricDueThisWeek: "vencem esta semana",
    // Commitments section redesign (fase 1)
    eventLabel: "Evento",
    financialImpact: "Impacto financeiro",
    maturityOf: "Vencimento de {code}",
    cashAvailable: "Caixa disponível",
    filterType: "Tipo",
    filterEventValue: "Valor",
    filterStatus: "Status",
    filterPeriod: "Período",
    metricEvents: "eventos",
    metricPending: "pendentes",
    metricResolved: "concluídos",
    metricImpacted: "impactado",
    // Commitments section redesign (fase 2)
    recalcRecommendations: "Recalcular recomendações",
    recalcTooltip: "Gera novas recomendações com base nos critérios de priorização atuais.",
    recommendationReason: "Motivo da recomendação",
    rankingDefaultOrderHint: "Defina critérios para personalizar a ordem das recomendações.",
    // Commitments section redesign (fase 3) — alocação por estratégia
    allocationByStrategyTitle: "Alocação por estratégia",
    allocationByStrategyEmpty: "Sem dados de alocação disponíveis",
    allocationByStrategyNoAllocation: "Cliente sem alocação em produtos com estratégia definida",
    allocationByStrategyNoReferenceProfile: "Perfil do cliente não corresponde a nenhuma carteira de referência",
    allocationByStrategyDataUnavailable: "Dados não disponíveis",
    allocationByStrategySimulated: "Simulado",
    allocationStrategyPosfixado: "Pós-fixado",
    allocationStrategyPrefixado: "Pré-fixado",
    allocationStrategyInflacao: "Inflação",
    allocationStrategyRendaVariavel: "Renda Variável",
    allocationStrategyRetornoAbsoluto: "Retorno Absoluto/MM",
    allocationStrategyAlternativo: "Alternativos",
    allocationStrategyNaoInformada: "Não informada",
    allocationStrategyRendaFixaGlobal: "Renda Fixa Global",
    allocationStrategyRendaVariavelGlobal: "Renda Variável Global",
    allocationStrategyInternacional: "Internacional",
    allocationStrategyMultimercado: "Multimercado",
    allocationStrategyNaoClassificada: "Não classificada",
}

